<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Historical Tracking Trips</ion-title>
        <!-- <ion-buttons slot="end">
                <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                    <ion-icon name="ellipsis-horizontal"></ion-icon>
                </ion-button>
            </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        {{filteredTrips.length}} Filtered Trips
        <!-- <ion-label class="ion-text-wrap">
                <span class="line1">Start Range: {{vm.filter?.startingDate}}</span><br />
                <span class="line1">End Range:   {{vm.filter?.endingDate}}</span><br />
                <span class="line1">Drivers:     {{vm.filter?.selectedDrivers}}</span>
            </ion-label> -->
    </ion-list-header>

    <ion-list class="ion-no-padding">
        <!-- @for (trip of filteredTrips; track $index; let idx = $index) { -->
        @for (trip of filteredTrips; track trip; let idx = $index) {
        <div>
            <ion-item class="ion-no-padding">
                <ion-grid>
                    <ion-row class="ion-align-items-center">
                        <ion-col class="sequenceCol" size="2" size-md="1">
                            <!-- <span class="letter">{{idx+1}}</span> -->
                            {{idx+1}}
                        </ion-col>
                        <ion-col class="legDescCol" size="auto" size-md="10" ion-float-right>
                            <span class="line1">Date: {{getTripDate(trip)}}</span><br />
                            <span class="line2">Time: {{getStartTime(trip)}} - {{getEndTime(trip)}}</span><br />
                            <span class="line2">Duration: {{getDuration(trip)}}</span><br />
                            <span class="line2">Type: {{getTripType(trip)}}</span><br />
                            <span class="line2">Driver: {{getDriver(trip)}}</span><br />
                            <span class="line2">Tickets: {{getNumTickets(trip)}}</span><br />
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-item>
        </div>
        }
    </ion-list>
</ion-content>

<ion-footer>
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button data-test="nextButton" [disabled]=vb.disabled title="Next" (click)="onNextClick()">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-footer>